import React from "react";
import ReactMarkdown, { Options } from "react-markdown";
import "github-markdown-css/github-markdown.css";
import styled from "styled-components";
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'

interface IProps extends Options {}

const MarkdownViewer: React.FC<IProps> = props => {
  const { ...MarkdownProps } = props;

  return (
    <MarkDown
      className={"markdown-body"}
        // @ts-ignore
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      {...MarkdownProps}
    />
  );
};

export default MarkdownViewer;

const MarkDown = styled(ReactMarkdown)`
  code {
    background-color: #ddd923;
  }
`;
